import * as React from 'react'
import { styled } from '@mui/material/styles'
import Divider, { dividerClasses } from '@mui/material/Divider'
import Menu from '@mui/material/Menu'
import MuiMenuItem from '@mui/material/MenuItem'
import { paperClasses } from '@mui/material/Paper'
import { listClasses } from '@mui/material/List'
import ListItemText from '@mui/material/ListItemText'
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded'
import MenuButton from './MenuButton'
import { useNavigate } from "react-router-dom";

const MenuItem = styled(MuiMenuItem)({
  margin: '2px 0',
})

export default function OptionsMenu({ signOut }) {

  const [anchorEl, setAnchorEl] = React.useState(null)
  const navigate = useNavigate()

  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <React.Fragment>
      <MenuButton
        aria-label="Open menu"
        onClick={handleClick}
        sx={{ borderColor: 'transparent' }}
      >
        <MoreVertRoundedIcon />
      </MenuButton>
      <Menu
        anchorEl={anchorEl}
        id="menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        sx={{
          [`& .${listClasses.root}`]: {
            padding: '4px',
          },
          [`& .${paperClasses.root}`]: {
            padding: 0,
          },
          [`& .${dividerClasses.root}`]: {
            margin: '4px -4px',
          },
        }}
      >
        <MenuItem onClick={() => navigate('/account')}>Mon compte</MenuItem>
        <MenuItem onClick={handleClose}>Paramètres</MenuItem>
        <Divider />
        <MenuItem
          onClick={() => {
              signOut()
              handleClose()
          }}
        >
          <ListItemText>Déconnexion</ListItemText>
        </MenuItem>
      </Menu>
    </React.Fragment>
  )
}
